import script from "./ReportLayoutEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportLayoutEditorView.vue?vue&type=script&setup=true&lang=js"

import "./ReportLayoutEditorView.vue?vue&type=style&index=0&id=9f8b48ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f8b48ae"]])

export default __exports__